import { Box, Grid, Typography, Button } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { useState } from 'react';
import ReservationModal from '../ReservationModal/ReservationModal';
const Request = () => {
    const [openModal, setOpenModal] = useState(false)
    const handleClick = () => {
        setOpenModal(true)
    }
    const handleClose = () => {
        setOpenModal(false)
    }
    return (
        <>
            <ReservationModal openVar={openModal} onClose={handleClose} ></ReservationModal>
            <Grid container sx={{
                width: "100%",
                minHeight: "15rem",
                backgroundColor: "secondary.main",
                padding: "2rem",
                display: "flex",
                justifyContent: "center",
                alignContent: "center"
            }}>
                <Box sx={{
                    textAlign: "center"
                }}>
                    <Typography variant="subtitle2" mb={1} sx={{
                        textTransform: "uppercase",
                        fontWeight: "bold",
                        color: "white"
                    }}>Kalkulace ceny online </Typography>
                    <Typography variant="h3" sx={{
                        fontWeight: "bold",
                        color: "white"
                    }}>Nezávazná poptávka</Typography>
                    <Grid container sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 1.5,
                        gap: 4
                    }}>
                        <Grid item xs={12} md={6}>
                            <Box sx={{
                                display: "flex",
                                gap : 2,
                                alignItems: "center",
                                justifyContent : "center"
                            }}>
                                <PhoneIcon sx={{ color: "white" }}></PhoneIcon>
                                <Typography component="a" fontWeight={600} href='tel:+420777276064' variant="body2" color={"white"}>777 276 064</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md>
                            <Button variant="contained" onClick={handleClick} color='primary'>
                                <Typography variant="h6" color={"white"}>Online Formulář</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </>
    );
};

export default Request;